import { render, staticRenderFns } from "./UserAccessRestriction.vue?vue&type=template&id=553cd4f3&scoped=true"
import script from "./UserAccessRestriction.vue?vue&type=script&lang=js"
export * from "./UserAccessRestriction.vue?vue&type=script&lang=js"
import style0 from "./UserAccessRestriction.vue?vue&type=style&index=0&id=553cd4f3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553cd4f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553cd4f3')) {
      api.createRecord('553cd4f3', component.options)
    } else {
      api.reload('553cd4f3', component.options)
    }
    module.hot.accept("./UserAccessRestriction.vue?vue&type=template&id=553cd4f3&scoped=true", function () {
      api.rerender('553cd4f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserAccessRestriction.vue"
export default component.exports